import { Pipe, PipeTransform, inject } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { ColumnType } from '../model/column-type';
import { formatNumber } from '@angular/common';

/**
 * Converts values recieved from SuperX backend into JS-Format
 */
@Pipe( { name: 'biaColumnFormat' } )
export class BiaColumnFormatPipe implements PipeTransform {
    private locale = inject( LOCALE_ID );

    transform( value: any, type: ColumnType ): any {
        if ( type === ColumnType.DecimalColumn && value != null ) {
            const numValue = typeof value === 'string' ? parseFloat( value ) : value;
            return formatNumber( numValue, this.locale, '1.2-2' );
        }
        return value;
    }
}
